module.exports = __webpack_public_path__ + "img/leaderboard.950772e7.png";